import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { User } from 'src/app/pages/device/settings/user-management/user-management.component';

@Component({
    selector: 'app-modal-form-users',
    imports: [FormsModule],
    templateUrl: './modal-form-users.component.html'
})
export class ModalFormUsersComponent {
  @Input() user: User = {
    id: '',
    name: '',
    email: '',
    phone: '',
    grupo: '',
    expiredDate: undefined,
    active: false,
    createdAt: new Date(),
    usageTime: 0
  };
  @Input() editing: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}

  getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  closeModal(): void {
    this.activeModal.close();
  }

  saveModal(): void {
    this.activeModal.close(this.user);
  }
}

